import { FC } from 'react'
import { Droppable } from 'react-beautiful-dnd'
import { Box } from '@mui/material'

import { FORM_DROPPABLE_TYPE } from '@constants'
import { WindowConfigTabType } from '@types'

import { DraggableLineOnSection } from './DraggableLineOnSection'

type ContainerTabPanelProps = {
  tab?: WindowConfigTabType
  index: number
  containerId: number | string | null | undefined
}

export const ContainerTabPanel: FC<ContainerTabPanelProps> = ({ tab, containerId, index }) => {
  if (!tab) return null
  const tabId = tab?.id

  return (
    <Droppable
      droppableId={`containerId:${containerId}_tabId:${tabId}`}
      type={FORM_DROPPABLE_TYPE.LINES}
    >
      {(provided, snapshot) => {
        return (
          <Box ref={provided.innerRef} {...provided.droppableProps}>
            {tab?.lines.map((line, lineIndex) => {
              return (
                <DraggableLineOnSection
                  key={line.id}
                  containerId={containerId}
                  index={lineIndex}
                  line={line}
                  tabId={tabId}
                />
              )
            })}
            {provided.placeholder}
          </Box>
        )
      }}
    </Droppable>
  )
}
